import styled from "styled-components"
import {MdKeyboardArrowRight, MdKeyboardArrowLeft} from "react-icons/md"
import BtnOutline from "../../shared/button/BtnOutline"
import { scrollToTop } from "../../../helper/scrollToTop"
import { useSelector } from "react-redux"
import { useState } from "react"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from "react-redux"
import RouteLine from "../sections/routePlanlama/others/RouteLine"
import { useEffect } from "react"
import {MdDragIndicator} from "react-icons/md"
import { setRoute } from "../../../features/addLoad/addLoadSlice"

const Container = styled.div`
  display: flex;
  flex-direction: column;

  h4{
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-xl);
    margin-left: 25px;
  }

  .route-content{
    width: auto;
    min-height: 300px;
    display: flex !important;
    gap: 10px;
    margin-left: 40px;

    .route-line-container{
      margin: 22px 0;
      display: flex;
      flex-direction: column;

      .route-line-item{
        display: flex;
        align-items: center;
        height: 60px;
      }
    }

    .route-item{
      display: flex;
      align-items: center;
      height: 60px;



    }


    .route-item-content{
        height: 40px !important;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        background-color: ${({theme}) => theme.secondaryBgColor};
        display: flex;
        align-items: center;
        border-radius: 10px;
        min-width: 400px;

        .rota-point{
          background-color: ${({theme}) => theme.rotaPlanlamaIndexBgColor};
          color: ${({theme}) => theme.reverseMainTextColor};
          width: 28px;
          height: 100%;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .rota-text{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          color: ${({theme}) => theme.mainTextColor};
          margin-left: 20px;
        }

        .drag-icon{
          font-size: 1.5rem;
          fill: ${({theme}) => theme.mainTextColor};
          margin-left: auto;
          margin-right: 5px;
        }
      }
  }

  .bottom-btn-container{
    width: 100%;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .icon{
        fill: var(--color-main);
        font-size: 1.6rem;
    }

    span{
        color: ${({theme}) => theme.mainTextColor};
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
    }
  }

`
const RoutePlanlamaSection = ({setPhase}) => {

  const {yuklemeDataList, bosaltmaDataList, route} = useSelector(state => state.addLoad)

  const dispatch = useDispatch()
  const [list, setList] = useState([])

  useEffect(() => {
    if(route.length < 1){
      const yuklemeList = yuklemeDataList.map((item,i) => {
        return {...item, order: i+1} 
      })
      
      const bosaltmaList = bosaltmaDataList.map((item,i) => {
        return {...item, order: i+1}
      })

      setList([...yuklemeList, ...bosaltmaList])
    }
    else{

      let yukleme = 0
      let bosaltma = 0

      const updatedlist = route.map((item) => {
        if(item.locationType === "yukleme"){
          yukleme++
          return {...item, order:yukleme}
        }
        if(item.locationType === "bosaltma"){
          bosaltma++
          return {...item, order:bosaltma}
        }
      })
      setList(updatedlist)
    }
  },[yuklemeDataList, bosaltmaDataList])

  const onDragEnd = (result) => {
    if (!result.destination) return; // Sürükleme hedefi yoksa
    let yukleme = 0
    let bosaltma = 0

    const reorderedItems = Array.from(list);
    const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
    reorderedItems.splice(result.destination.index, 0, movedItem);

    const updatedList = reorderedItems.map((item) => {
      if(item.locationType === "yukleme"){
        yukleme++
        return {...item, order:yukleme}
      }
      if(item.locationType === "bosaltma"){
        bosaltma++
        return {...item, order:bosaltma}
      }
    })

    setList(updatedList)

    dispatch(setRoute(updatedList))
  };

 
  return (
    <Container>
      <h4>Rota Planlama</h4>
      
          <div className="route-content">
            <div className="route-line-container">
              {
                list.map((_, index)  => (
                  <div className="route-line-item">
                      <RouteLine type={index === 0 ? "start" : index === list.length -1 ? "end" : "mid"}/>
                  </div>
                ))
              }
            </div>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="rota-planlama">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {
                      list?.map((item, index) => {
                        if(item.locationType === "yukleme"){
                          return (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                            {(provided) => (
                              <div
                                className={"route-item"}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                              >
                                <div className="route-item-content">
                                  <div className="rota-point">{index+1}</div>
                                  <div className="rota-text">{item.order}. {item.locationType === "yukleme" ? "Yükleme" : "Boşaltma"}{item.locationData.location}</div>
                                  <MdDragIndicator className="drag-icon"/>
                                </div>
                              </div>
                            )}
                          </Draggable>
                          )
                        }
                        if(item.locationType === "bosaltma"){
                          return (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                            {(provided) => (
                              <div
                                className={"route-item"}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                              >
                                
                                <div className="route-item-content">
                                  <div className="rota-point">{index+1}</div>
                                  <div className="rota-text">{item.order}. {item.locationType === "yukleme" ? "Yükleme" : "Boşaltma"} {item.locationData.location && `(${item.locationData.location})`}</div>
                                  <MdDragIndicator className="drag-icon"/>
                                </div>
                              </div>
                            )}
                          </Draggable>
                          )
                        }      
                      })
                    }
                  </div>
                )}
              </Droppable>
            </DragDropContext>

          </div>
          <div className="bottom-btn-container">
          <BtnOutline height={"40px"} width={"120px"} radius={"10px"} handleClick={() => {setPhase({id: 2, name:"Boşaltma"});scrollToTop()}} >
                <MdKeyboardArrowLeft className="icon"/>
                <span>Boşaltma</span>
          </BtnOutline>
          <BtnOutline height={"40px"} width={"120px"} radius={"10px"} handleClick={() => {setPhase({id: 4, name:"Yük"});scrollToTop()}} >
              <span>Yük</span>
              <MdKeyboardArrowRight className="icon"/>
          </BtnOutline>
        </div>
    </Container>
  )
}

export default RoutePlanlamaSection